import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function PainAgitation() {
  const pains = ['Que ibas a pasar semanas sin dormir más de 2 horas seguidas', 'Que el agotamiento extremo puede generar síntomas de depresión aunque no tengas depresión', 'Que cada vez que intentas cambiar algo — el bebé parece empeorar antes de mejorar', 'Que los consejos contradictorios de familia y redes sociales te iban a dejar más confundida que antes', 'Que el método de llanto controlado que "todos usan" te iba a hacer sentir como la peor mamá del mundo'];
  return <section className="bg-crema py-24 px-6" data-id="element-321">
      <div className="max-w-3xl mx-auto" data-id="element-322">
        <FadeIn data-id="element-323">
          <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-8 text-center" data-id="element-324">
            Lo que nadie te dijo antes de que naciera tu bebé
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-325">
          <p className="text-lg text-texto mb-4" data-id="element-326">
            Antes del parto todo el mundo te habló de lo bonito.
          </p>
          <p className="text-lg text-texto mb-10" data-id="element-327">
            Del amor que ibas a sentir. Del olor de tu bebé. De ese primer
            momento de conexión.
            <br data-id="element-328" />
            <br data-id="element-329" />
            <span className="font-bold text-azul-noche" data-id="element-330">
              Nadie te habló de esto:
            </span>
          </p>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-331">
          {pains.map((pain, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-332">
              <div className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-white/50" data-id="element-333">
                <div className="flex-shrink-0 mt-1 mr-4" data-id="element-334">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF8A8A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-335">
                    <line x1="18" y1="6" x2="6" y2="18" data-id="element-336"></line>
                    <line x1="6" y1="6" x2="18" y2="18" data-id="element-337"></line>
                  </svg>
                </div>
                <p className="text-lg text-texto" data-id="element-338">{pain}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-339">
          <div className="bg-white border-2 border-lila-suave rounded-2xl p-8 shadow-lg relative overflow-hidden" data-id="element-340">
            <div className="absolute top-0 left-0 w-2 h-full bg-lila-suave" data-id="element-341"></div>
            <p className="text-xl text-azul-noche font-medium leading-relaxed" data-id="element-342">
              Y sobre todo — nadie te dijo que hay una forma de enseñarle a tu
              bebé a dormir más horas que{' '}
              <span className="font-bold" data-id="element-343">no requiere abandonarlo</span>,{' '}
              <span className="font-bold" data-id="element-344">no requiere ignorarlo</span> y{' '}
              <span className="font-bold" data-id="element-345">
                no requiere sacrificar el vínculo
              </span>{' '}
              que construiste desde el primer día.
              <br data-id="element-346" />
              <br data-id="element-347" />
              Eso existe. Y funciona. Y está basado en cómo funciona realmente
              el cerebro de un bebé de 0 a 6 meses.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}